export const mockSalaryStructureResponse = {
  rescode: 1,
  message: 'Success',
  data: {
    structure: {
      id: 1,
      userId: 201,
      baseSalary: 30000,
      hra: 5000,
      da: 3000,
      travelAllowance: 2000,
      medicalAllowance: 1500,
      otherAllowance: 0,
      pf: 1800,
      esi: 500,
      tds: 1000,
      professionalTax: 200,
      otherDeduction: 0,
      effectiveFrom: '2025-01-01',
      isActive: 1,
    },
    staff: {
      UserId: 201,
      FirstName: 'Dr. Neha',
      LastName: 'Agarwal',
      designation: 'Doctor',
      joining_date: '2021-06-01',
    },
  },
};

export const mockPayrollListResponse = {
  rescode: 1,
  message: 'Success',
  data: {
    totalRecords: 3,
    payrolls: [
      {
        id: 1,
        userId: 201,
        month: 3,
        year: 2026,
        baseSalary: 30000,
        hra: 5000,
        da: 3000,
        travelAllowance: 2000,
        medicalAllowance: 1500,
        otherAllowance: 0,
        totalEarnings: 41500,
        pf: 1800,
        esi: 500,
        tds: 1000,
        professionalTax: 200,
        otherDeduction: 0,
        totalDeductions: 3500,
        totalWorkingDays: 26,
        presentDays: 22,
        absentDays: 4,
        perDaySalary: 1596.15,
        absentDeduction: 6384.62,
        bonus: 2000,
        bonusNote: 'Performance bonus',
        advanceDeduction: 5000,
        grossSalary: 43500,
        netSalary: 28615.38,
        status: 'paid',
        paidDate: '2026-03-28',
        staff_name: 'Dr. Neha Agarwal',
        designation: 'Doctor',
      },
      {
        id: 2,
        userId: 202,
        month: 3,
        year: 2026,
        baseSalary: 25000,
        hra: 4000,
        da: 2500,
        travelAllowance: 1500,
        medicalAllowance: 1000,
        otherAllowance: 0,
        totalEarnings: 34000,
        pf: 1500,
        esi: 400,
        tds: 800,
        professionalTax: 200,
        otherDeduction: 0,
        totalDeductions: 2900,
        totalWorkingDays: 26,
        presentDays: 24,
        absentDays: 2,
        perDaySalary: 1307.69,
        absentDeduction: 2615.38,
        bonus: 0,
        bonusNote: '',
        advanceDeduction: 0,
        grossSalary: 34000,
        netSalary: 28484.62,
        status: 'processed',
        paidDate: null,
        staff_name: 'Priya Sharma',
        designation: 'Therapist',
      },
      {
        id: 3,
        userId: 203,
        month: 3,
        year: 2026,
        baseSalary: 20000,
        hra: 3000,
        da: 2000,
        travelAllowance: 1000,
        medicalAllowance: 800,
        otherAllowance: 0,
        totalEarnings: 26800,
        pf: 1200,
        esi: 350,
        tds: 600,
        professionalTax: 200,
        otherDeduction: 0,
        totalDeductions: 2350,
        totalWorkingDays: 26,
        presentDays: 26,
        absentDays: 0,
        perDaySalary: 1030.77,
        absentDeduction: 0,
        bonus: 0,
        bonusNote: '',
        advanceDeduction: 0,
        grossSalary: 26800,
        netSalary: 24450,
        status: 'draft',
        paidDate: null,
        staff_name: 'Rahul Verma',
        designation: 'Therapist',
      },
    ],
  },
};

export const mockPayrollDetailsResponse = {
  rescode: 1,
  message: 'Success',
  data: {
    payroll: {
      id: 1,
      userId: 201,
      month: 3,
      year: 2026,
      baseSalary: 30000,
      hra: 5000,
      da: 3000,
      travelAllowance: 2000,
      medicalAllowance: 1500,
      otherAllowance: 0,
      totalEarnings: 41500,
      pf: 1800,
      esi: 500,
      tds: 1000,
      professionalTax: 200,
      otherDeduction: 0,
      totalDeductions: 3500,
      totalWorkingDays: 26,
      presentDays: 22,
      absentDays: 4,
      perDaySalary: 1596.15,
      absentDeduction: 6384.62,
      bonus: 2000,
      bonusNote: 'Performance bonus',
      advanceDeduction: 5000,
      grossSalary: 43500,
      netSalary: 28615.38,
      status: 'paid',
      paidDate: '2026-03-28',
    },
    staff: {
      UserId: 201,
      FirstName: 'Dr. Neha',
      LastName: 'Agarwal',
      Email: 'neha.agarwal@jcdc.in',
      Phone: '9876501234',
      designation: 'Doctor',
      joining_date: '2021-06-01',
      address: '8, Lal Kothi, Jaipur, Rajasthan',
    },
    clinic: {
      id: 1,
      name: 'Vistaar',
      address: 'Jaipur, Rajasthan',
      phone: '9999999999',
      email: 'info@vistaar.com',
    },
  },
};

export const mockPayrollSummaryResponse = {
  rescode: 1,
  message: 'Success',
  data: {
    totalStaff: 3,
    totalGross: 104300,
    totalNet: 81550,
    totalDeductions: 8750,
    totalBonuses: 2000,
    totalAdvanceDeductions: 5000,
    draftCount: 1,
    processedCount: 1,
    paidCount: 1,
  },
};

export const mockAdvanceListResponse = {
  rescode: 1,
  message: 'Success',
  data: {
    totalRecords: 2,
    advances: [
      {
        id: 1,
        userId: 201,
        amount: 5000,
        date: '2026-03-10',
        reason: 'Medical emergency',
        status: 'deducted',
        deductedInPayrollId: 1,
        staff_name: 'Dr. Neha Agarwal',
        designation: 'Doctor',
      },
      {
        id: 2,
        userId: 202,
        amount: 3000,
        date: '2026-03-15',
        reason: 'Personal requirement',
        status: 'approved',
        deductedInPayrollId: null,
        staff_name: 'Priya Sharma',
        designation: 'Therapist',
      },
    ],
  },
};

export const mockStaffOverviewResponse = {
  rescode: 1,
  message: 'Success',
  data: {
    staff: [
      {
        UserId: 201,
        FirstName: 'Dr. Neha',
        LastName: 'Agarwal',
        designation: 'Doctor',
        joining_date: '2021-06-01',
        hasSalaryStructure: true,
        monthlySalary: 41500,
        payrollStatus: 'paid',
      },
      {
        UserId: 202,
        FirstName: 'Priya',
        LastName: 'Sharma',
        designation: 'Therapist',
        joining_date: '2022-03-15',
        hasSalaryStructure: true,
        monthlySalary: 34000,
        payrollStatus: 'processed',
      },
      {
        UserId: 203,
        FirstName: 'Rahul',
        LastName: 'Verma',
        designation: 'Therapist',
        joining_date: '2023-01-10',
        hasSalaryStructure: true,
        monthlySalary: 26800,
        payrollStatus: 'draft',
      },
      {
        UserId: 204,
        FirstName: 'Anjali',
        LastName: 'Singh',
        designation: 'Receptionist',
        joining_date: '2024-06-01',
        hasSalaryStructure: false,
        monthlySalary: 0,
        payrollStatus: null,
      },
    ],
  },
};
